import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const HelpChat = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M13.094 18.096h-.227l-.189.125-4.45 2.96a.247.247 0 0 1-.384-.205v-2.88h-.75c-1.33 0-2.38-.44-3.095-1.156-.715-.715-1.155-1.765-1.155-3.094v-6c0-1.33.44-2.38 1.155-3.095s1.765-1.155 3.095-1.155h10c1.33 0 2.379.44 3.094 1.155.716.715 1.156 1.765 1.156 3.095v6c0 1.33-.44 2.379-1.156 3.094-.715.716-1.765 1.156-3.094 1.156z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M12.094 11.776v-.21c0-.68.42-1.04.84-1.33.41-.28.82-.64.82-1.3 0-.92-.74-1.66-1.66-1.66s-1.66.74-1.66 1.66'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M12.09 14.166h.008'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.094 18.846h4c3 0 5-2 5-5v-6c0-3-2-5-5-5h-10c-3 0-5 2-5 5v6c0 3 2 5 5 5v2.13c0 .8.89 1.27 1.55.83zm-3.41-9.91a2.406 2.406 0 0 1 2.41-2.41 2.406 2.406 0 0 1 2.41 2.41c0 1.053-.692 1.609-1.146 1.919-.194.134-.32.24-.4.348a.56.56 0 0 0-.114.363v.21a.75.75 0 0 1-1.5 0v-.21c0-1.077.709-1.632 1.164-1.947l.003-.002c.185-.126.306-.23.384-.335a.54.54 0 0 0 .109-.346.906.906 0 0 0-.91-.91.906.906 0 0 0-.91.91.75.75 0 1 1-1.5 0m1.655 5.23a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
